import { HOME_TITLE, HOME_DESCRIPTION } from '../components/public/homeContent.js'
const ORIGIN = 'https://vizu.ink'
export const SEO = {
  update(title, description, image, url) {
    const fullTitle = title ? (title.includes('Vizu') ? title : `${title} | Vizu.ink`) : HOME_TITLE
    const text = description || HOME_DESCRIPTION
    const canonical = (url || `${ORIGIN}/`).split('#')[0]
    document.title = fullTitle
    this.updateMeta('description', text, 'name')
    this.updateMeta('og:title', fullTitle)
    this.updateMeta('og:description', text)
    this.updateMeta('og:image', image || `${ORIGIN}/images/logo.webp`)
    this.updateMeta('og:url', canonical)
    this.updateMeta('og:type', 'website')
    this.updateMeta('og:site_name', 'Vizu.ink')
    this.updateMeta('twitter:card', 'summary_large_image', 'name')
    this.updateMeta('twitter:title', fullTitle, 'name')
    this.updateMeta('twitter:description', text, 'name')
    this.updateMeta('twitter:image', image || `${ORIGIN}/images/logo.webp`, 'name')
    this.updateMeta('twitter:url', canonical, 'name')
    let link = document.querySelector('link[rel="canonical"]')
    if (!link) { link = document.createElement('link'); link.rel = 'canonical'; document.head.appendChild(link) }
    link.href = canonical
  },
  setIndexable(value) { this.updateMeta('robots', value ? 'index,follow' : 'noindex,follow', 'name') },
  updateMeta(property, content, attrName = 'property') {
    let tag = document.querySelector(`meta[${attrName}="${property}"]`)
    if (!tag) { tag = document.createElement('meta'); tag.setAttribute(attrName, property); document.head.appendChild(tag) }
    tag.content = content
  },
  reset() { this.update(HOME_TITLE, HOME_DESCRIPTION) },
}
